import {ThisExpression} from 'estree';

export function execThisExpression(exp: ThisExpression, context: Object) {
    return context;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/render/runTime/expression/thisExpression.ts